<!-- @veltra/icons generated sha256:a38d8959fa6fe59c gen:8 source:src/svg/normal/question-filled.svg -->
<script setup lang="ts">
defineOptions({ name: 'QuestionFilled' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="M14.994 8a7 7 0 1 0-14 0 7 7 0 0 0 14 0M5.86 6.13a2.195 2.195 0 0 1 2.134-1.69c1.21 0 2.192.983 2.192 2.191 0 .97-.743 1.721-1.485 2.024a.34.34 0 0 0-.207.315v.292a.51.51 0 0 1-.503.505.506.506 0 0 1-.497-.505V8.97c0-.56.34-1.039.827-1.24l.002-.001c.495-.201.863-.657.863-1.098a1.192 1.192 0 0 0-2.28-.484c-.113.252-.33.484-.607.484-.269 0-.502-.231-.439-.5m1.607 5.042a.527.527 0 1 1 1.054 0 .527.527 0 0 1-1.054 0"
    />
  </svg>
</template>
